import { cn } from "@win-reality/react-ui";

import type { IPlayer } from "../../../store/types";

interface PlayerRowProps {
  player: IPlayer;
  isActive: boolean;
  onClick: () => void;
}

/**
 * PlayerRow - Clickable roster card for batting practice
 *
 * Matches the roster card design from GameSetup/LineupList
 * (rounded border, position badge, player name) but acts as
 * a button with an orange active highlight.
 */
export const PlayerRow = ({ player, isActive, onClick }: PlayerRowProps) => {
  const displayName = `${player.firstName} ${player.lastName}`;

  return (
    <button
      type="button"
      className={cn(
        // Size
        "w-full",
        // Layout
        "flex items-center",
        // Spacing
        "gap-3 px-2 py-2",
        // Border
        "rounded border",
        // Background
        "bg-white",
        // Text
        "text-left",
        // Effects
        "transition-colors",
        // States
        isActive
          ? "border-blue bg-blue/10"
          : "border-gray-200 hover:bg-gray-50",
      )}
      onClick={onClick}
    >
      {/* Position badge */}
      <div
        className={cn(
          // Size
          "h-8 w-8 shrink-0",
          // Layout
          "flex items-center justify-center",
          // Border
          "rounded",
          // Text
          "text-sm font-semibold text-white",
          // States
          isActive ? "bg-blue" : "bg-badge-batter",
        )}
      >
        AB
      </div>

      {/* Player name */}
      <span className="flex-1 text-sm font-medium text-text-light">
        {displayName}
      </span>
    </button>
  );
};
